module.exports = __webpack_public_path__ + "gu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gu.svg
// module id = 586
// module chunks = 0